<div class="flex flex-col justify-center items-center relative h-[50px] w-[60px] border-b border-solid border-c-gb">
  <!-- <span class="date">{{ date.value?.format('MM.DD') }}</span> -->
  <span class="date text-m">{{ showMonth ? date.i18nDate : date.number }}</span>
  <!-- <span class="date">{{ date.value | dateformat: ['MD'] }}</span> -->
  <span class="weekday text-[10px] text-c-l2" [class.is-holiday]="date.isLegalHoliday || date.holidayName">
    {{
      date.isCurrentDay
        ? ("word.today" | translate)
        : isInternational
          ? (date.dayName | translate)
          : date.holidayName || (date.dayName | translate)
    }}
  </span>
  <span
    class="flag absolute top-0 right-0 px-[2px] text-s rounded-sm"
    [class.is-off]="date.isOff"
    *ngIf="date.isLegalHoliday || date.isOff">
    <!-- {{ date.isLegalHoliday ? '休' : '班'}} -->
    {{ (date.isLegalHoliday ? "word.rest" : "word.work") | translate }}
  </span>
</div>
